import { usePlanStatus } from "@/react/hooks/usePlanStatus";

import { ExpiredTrial } from "./ExpiredTrial";
import { SubscriptionCancelled } from "./SubscriptionCancelled";
import { SubscriptionIncompleteExpired } from "./SubscriptionIncompleteExpired";
import { SubscriptionOnGracePeriod } from "./SubscriptionOnGracePeriod";
import { SubscriptionWithIncompletePayment } from "./SubscriptionWithIncompletePayment";

export const SubscriptionStatusBanner = () => {
  const {
    isExpiredTrial,
    isCommunitySubscriptionIncompleteExpired,
    isCommunitySubscriptionFullyCancelled,
    isCommunitySubscriptionOnGracePeriod,
    hasCommunityIncompletePayment,
  } = usePlanStatus();

  if (isExpiredTrial) {
    return <ExpiredTrial />;
  }

  if (hasCommunityIncompletePayment) {
    return <SubscriptionWithIncompletePayment />;
  }

  if (isCommunitySubscriptionIncompleteExpired) {
    return <SubscriptionIncompleteExpired />;
  }

  if (isCommunitySubscriptionFullyCancelled) {
    return <SubscriptionCancelled />;
  }

  if (isCommunitySubscriptionOnGracePeriod) {
    return <SubscriptionOnGracePeriod />;
  }

  return null;
};
